/**
 * 所有用到的权限点，需要在此处先注册
 * 注意： 权限点绝对不能重复
 * @author tylerzzheng
 */
const AUTH_POINT_MAP = {
  /* 路由 菜单 */
  menuTaskList: 'tcc.menu.task.list-r',
  menuTaskAllTask: 'tcc.menu.task.all.task-r',
  menuTaskGoal: 'tcc.menu.task.Goal-r',
  menuTaskFollowRecord: 'tcc.menu.task.follow.record-r',
  menuTaskCallRecord: 'tcc.menu.task.call.record-r',
  menuTaskSmsRecord: 'tcc.menu.task.sms.record-r',
  menuTaskRetainRecord: 'tcc.menu.task.retain.record-r',
  menuLeadHotline: 'tcc.menu.lead.hotline-r',
  menuLeadHotlineClueCollect400: 'tcc.menu.lead.hotline.clueCollect.400-r',
  menuLeadHotlineClueCollectIM: 'tcc.menu.lead.hotline.clueCollect.im-r',
  menuLeadHotlineCallIM: 'tcc.menu.lead.hotline.callIm-r',
  menuLeadHotlineCallSuccess: 'tcc.menu.lead.hotline.callSuccess-r',
  menuLeadListClaimed: 'tcc.menu.lead.list.claimed-r',
  menuLeadListUnclaimed: 'tcc.menu.lead.list.unclaimed-r',
  menuLeadListDiscard: 'tcc.menu.lead.list.discard-r',
  menuLeadAdd: 'tcc.menu.lead.add-r',
  menuLeadCirculateRecord: 'tcc.menu.lead.circulate.record-r',
  menuCustomerOpportunity: 'tcc.menu.customer.opportunity-r',
  menuCustomerDetail: 'tcc.menu.customer.detail-r',
  menuCustomerResource: 'tcc.menu.customer.resource-r',
  menuCustomerPurePool: 'tcc.menu.customer.pure-r',
  menuCustomerCompanyPool: 'tcc.menu.customer.company.pool-r',
  menuCustomerInvestigate: 'tcc.menu.customer.investigate-r',
  menuCustomerLinked: 'tcc.menu.customer.linked-r',
  menuCustomerTransfer: 'tcc.menu.customer.transfer-r',
  menuCustomerTransTemp: 'tcc.menu.customer.trans.temp-r',
  menuCustomerLinkLog: 'tcc.menu.customer.link.log-r',
  menuCustomerFlowLog: 'tcc.menu.scrm.flow.log-r',
  menuCustomerOrderDetail: 'tcc.menu.customer.deal-r',
  menuCustomerAssignRecord: 'tcc.menu.customer.assign.record-r',
  menuCustomerConflictRecord: 'tcc.menu.customer.conflict.record-r',
  menuUnbind: 'tcc.permission.unbind-u',
  menuBindFailure: 'tcc.permission.bind.failure-r',
  menuPerformance: 'tcc.permission.performance-r',
  menuConfigTCCC: 'tcc.menu.config.tccc-r',
  menuConfigOrganization: 'tcc.menu.config.organization-r',
  menuConfigKnowledgeUpload: 'tcc.menu.config.acknowledge-mgt',
  menuConfigTags: 'tcc.menu.config.tags-r',
  menuConfigRuleType: 'tcc.menu.config.rule.type-r',
  menuConfigSms: 'tcc.menu.config.sms-r',
  menuConfigNewCustomerTransfer: 'tcc.menu.config.lead.unconverted-r',
  menuConfigLeadRule: 'tcc.menu.config.lead.rule-r',
  menuConfigFollow: 'tcc.menu.config.follow-r',
  menuConfigTaskLog: 'tcc.menu.config.task.log-r',
  menuConfigRetainResourceList: 'tcc.menu.config.retain.resource.list-r',
  menuConfigRetainResourceEdit: 'tcc.menu.config.retain.resource.edit-r',
  menuConfigBatchInfo: 'tcc.menu.config.batch.info-r',
  menuConfigOperationLog: 'tcc.menu.config.operation.log-r',
  menuConfigLlmTuning: 'tcc.menu.task.llm.tuning-mgt',
  menuReportAgentTask: 'tcc.menu.report.agent.task-r',
  menuReportKanban: 'tcc.menu.report.kanban-r',
  menuReportKanbanAdmin: 'tcc.menu.report.kanbanAdmin-r',
  menuRobotCallRecord: 'tcc.menu.task.robot.call.record-r',
  menuRobotTask: 'tcc.menu.config.robot.task-r',
  menuMeetingRecord: 'tcc.menu.task.meeting.record-r',
  menuSaasConfig: 'tcc.menu.saas.config-r',
  // 质检方案管理
  menuTaskCallEvaluateR: 'tcc.menu.task.call.evaluate-r',
  menuTaskCallEvaluateU: 'tcc.menu.task.call.evaluate-u',
  // 关键词管理
  menuTaskCallKeyWordsR: 'tcc.menu.task.call.keywords-r',
  // 质检评分
  menuTaskCallScoreR: 'tcc.menu.task.call.score-r',
  menuTaskCallScoreU: 'tcc.menu.task.call.score-u',
  menuTaskCallScoreEx: 'tcc.menu.task.call.score-ex',
  /* 其它 */
  assignCustomer: 'tcc.permission.customerAssign-u',
  reassignLead: 'tcc.permission.reassignLead-u',
  principalCompany: 'tcc.permission.company.principal-u',
  mgtPublicTag: 'tcc.permission.businessConfig-mgt',
  questionnaireManage: 'tcc.permission.questionnaireManage-mgt',
  transferCustomer: 'tcc.permission.customerTransfer-mgt',
  releaseCustomer: 'tcc.permission.customerRelease-mgt',
  releaseCustomerNew: 'tcc.permission.customerRelease.module.new-mgt',
  releaseCustomerToCompany: 'tcc.permission.customerRelease.company-mgt',
  releaseCustomerToManager: 'tcc.permission.customerRelease.manager-mgt',
  mergeCustomer: 'tcc.permission.customerMerge-a',
  importReflux: 'tcc.customer.import.reflux-u',
  readTaskCount: 'tcc.permission.taskCount-r',
  readAllReport: 'tcc.permission.allReport-r',
  uploadLead: 'tcc.permission.leads.upload-mgt',
  // batchUploadLead: 'tcc.permission.leads.batchupload-mgt',
  commentOpportunity: 'tcc.permission.opportunities.comment-u',
  addFollowRecord: 'tcc.permission.addFollowRecord-a',
  simulatedUser: 'tcc.permission.mockLogin-a',
  switchModule: 'tcc.permission.switch.module-mgt',
  checkPhone: 'tcc.permission.customer.phone-r',
  checkOtherContactNumber: 'tcc.permission.customer.email_wechat_qq-r',
  exportOpportunity: 'tcc.permission.opportunities.export-ex',
  mgtGoal: 'tcc.permission.objective-mgt',
  modifyPermission: 'tcc.permission.authority-u',
  // 修改所属角色
  modifyRole: 'tcc.permission.role-u',
  robotOutBound: 'tcc.permission.robot.outbound.call-a',
  checkVoucher: 'tcc.permission.voucher-r',
  customerManualReflux: 'tcc.customer.manual.reflux-u',
  menuLeadListIntention: 'tcc.menu.lead.list.intention-r',
  menuLeadListPipeline: 'tcc.menu.lead.list.pipeline-r',
  menuLeadAddSdr: 'tcc.menu.lead.add.sdr-r',
  menuLeadListTransfer: 'tcc.menu.lead.list.transfer-r',
  mgtLeadListTransfer: 'tcc.menu.lead.list.transfer-mgt',
  leadTransferPermission: 'tcc.permission.leadTransfer-mgt',
  menuConfigFollowSdr: 'tcc.menu.config.follow.sdr-r',
  addFollowRecordSdrPermission: 'tcc.permission.addFollowRecord.sdr-a',
  menuTaskFollowRecordSdr: 'tcc.menu.task.follow.recordSDR-r',
  noUinCustomerMerge: 'tcc.permission.nonuincustomerMerge-mgt',
  menuTaskCallScoreExt1: 'tcc.menu.task.call.score-ext1',
  customerReflux_A: 'tcc.customer.reflux-a',
  menuTaskCallReexamineList: 'tcc.menu.task.call.reexamine list-r',
  menuTaskCallReexamineDetail: 'tcc.menu.task.call.reexamine-r',
  // 质检方案配置列表页
  menuConfigQualityCheckScheme: 'tcc.menu.task.call.qcplan-r',
  // 质检方案配置详情页
  menuConfigQualityCheckSchemeDetail: 'tcc.menu.task.call.qcplan.detail-r',
  // 质检任务管理,质检任务详情,质检任务创建
  menuConfigQualityCheckTask: 'tcc.menu.config.evaluate.task-mgt',
  // AI 画像简报
  tccPermissionAiCustomer360: 'tcc.permission.ai.customer360-r',
  // AI 话术助手
  aiCallingAssistant: 'tcc.permission.ai.calling.assistant-ext1',
  // AI 意向提炼
  tccPermissionAiLeadTransferExt1: 'tcc.permission.ai.leadTransfer-ext1',
  //
  menuLeadListRecall: 'tcc.menu.lead.list.recall-r',
  // 提前释放电销保护期
  customerReleaseisValidityPeriodMgt:
    'tcc.permission.customerReleaseisValidityPeriod-mgt',
  menuCustomerReleaselist: 'tcc.menu.customer.customerReleaselist-r',
  menuReportKanbanQualityinspection:
    'tcc.menu.report.kanbanQualityinspection-r',
  // 站内信
  menuNotification: 'tcc.menu.notification-r',
  notificationSend: 'tcc.permission.notification.message-u',
  notificationSendRecord: 'tcc.permission.notification.sendRecord-r',
  // 组织架构-修改所属公司
  modifyCompany: 'tcc.permission.organization.company-u',
  // 组织架构-修改库容（关联库容+考察库容）
  modifyPoolCapacity: 'tcc.permission.organization.poolCapacity-u',
} as const;

export default AUTH_POINT_MAP

export type AuthPointType = (keyof typeof AUTH_POINT_MAP)
